import React, { Component } from 'react';
import _ from 'lodash';
import { Col, FormGroup, Button } from "react-bootstrap";
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import {
  saveDeposit,
  savingEventDeposit,
  resetWizardState,
  prestineNavigateNext
} from "../../../../redux/actions/action_event";
import { forms, style, blue, warning, gray } from '../../../../utils/constants';
import { onlypositivenumbers } from '../../../../utils/functions';
import { STEP_SEQUENCE } from '../../logic';

const sectionBorder = {
  border: `1px solid ${gray}`,
  padding: '15px',
  marginRight: '0px',
  marginBottom: '15px'
};

const FormName = forms.eventinfo;
class EventDeposit extends Component {
  constructor(props) {
    super(props);
    this.handleNotToExceedLength = this.handleNotToExceedLength.bind(this);
    this.handleMakePayment = this.handleMakePayment.bind(this);
    this.generateUpdateErrors = this.generateUpdateErrors.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.props.dispatch(resetWizardState(STEP_SEQUENCE.Deposit));
  }

  handleMakePayment() {
    const {
      eventId,
      ccnumber,
      nameoncard,
      expiration,
      depositAmount,
      cvc,
      depositPaidOn,
      seasons,
      eventseason,
      eventname,
      savingDeposit
    } = this.props;

    const depositPaid = (depositPaidOn !== null && depositPaidOn !== undefined && depositPaidOn !== '');
    const season = _.find(seasons, { id: parseInt(eventseason) });

    if (depositPaid === false) {
      if (!savingDeposit) {
        const deposit = {
          nameOnCard: nameoncard,
          cardExpiration: expiration,
          ccNumber: ccnumber,
          depositAmount: depositAmount,
          cvc: cvc,
          season: season,
          eventname: eventname
        };

        this.props.dispatch(saveDeposit(eventId, deposit));
      }
    }
    else {
      this.props.dispatch(prestineNavigateNext());
    }
  }

  handleNotToExceedLength(evt) {
    const { value, maxLength } = evt.target;
    if ((value.length > maxLength)) {
      return evt.target.value = value.substring(0, maxLength);
    }
  }
  generateUpdateErrors(eventDetailsErrors) {
    const error = eventDetailsErrors.map((key, index) => {
      return (<li key={index} style={{ color: warning }}>{this.props.updateDepositErrors[key]}</li>)
    })
    return error;
  }

  render() {

    const {
      handleSubmit,
      eventname,
      ccnumber,
      nameoncard,
      expiration,
      cvc,
      depositAmount,
      depositPaidOn,
      depositConfirmation,
      saveComponentState,
      componentStateSaved,
      currentWizardStep,
      savingDeposit,
      updateDepositErrors
    } = this.props;

    const eventDepositErrors = Object.keys(updateDepositErrors);

    if (currentWizardStep === STEP_SEQUENCE.Deposit) {
      if ((saveComponentState === true) && (componentStateSaved === false)) {
        this.handleMakePayment();
      }
      if (componentStateSaved === true) {
        this.props.onComponentStateSaved(componentStateSaved)
      }
      if (eventDepositErrors.length > 0) {
        this.props.onComponentStateSaved(false)
      }
    }

    const depositPaid = (depositPaidOn !== null && depositPaidOn !== undefined && depositPaidOn !== '');

    return (
      <div style={{ marginTop: '1%' }} sm={5}>
        <form onSubmit={handleSubmit} className="form-horizontal">
          {
            eventDepositErrors.length > 0 &&
            (<Col sm={12} style={sectionBorder}>
              <h4 style={{ color: warning }}>* Please correct the following errors to proceed:</h4>
              <ul>
                {
                  this.generateUpdateErrors(eventDepositErrors)
                }
              </ul>
            </Col>)
          }
          {
            depositPaid &&
            (<span style={{ paddingLeft: '15px', color: blue, fontSize: '16px' }}>
              <i className="fa fa-info-circle" />&nbsp;&nbsp;Deposit received on {depositPaidOn} for the amount of ${depositAmount}, confirmation {depositConfirmation}.
            </span>)
          }
          {
            !depositPaid && (
              <Col md={9} style={{ border: `1px solid ${gray}`, padding: '15px', marginRight: '0px', marginBottom: '15px' }} >
                <FormGroup style={{ padding: '0 0 15px 25px', margin: '0' }}>
                  <h4 className='text-left' style={{ color: blue }}>{' '}Event Name - {eventname}</h4>
                  <h5 style={{ color: warning }} />
                </FormGroup>
                <div className='col-sm-6'>
                  <FormGroup sm={5}>
                    <label className={style.lblattrs4}>Name on card &nbsp;</label>
                    <Field
                      type='string'
                      name='name'
                      component='input'
                      className="form-control"
                      style={{ maxWidth: '180px' }}
                    />
                  </FormGroup>
                  <FormGroup sm={5}>
                    <label className={style.lblattrs4}>CC Number &nbsp;</label>
                    <Field
                      type='number'
                      name='ccnumber'
                      component='input'
                      onKeyDown={onlypositivenumbers}
                      onKeyUp={this.handleNotToExceedLength}
                      className="form-control no-spinners"
                      style={{ maxWidth: '180px' }}
                      maxLength='16'
                      placeholder='#### #### #### ####'
                    />
                  </FormGroup>
                  <FormGroup sm={5}>
                    <label className={style.lblattrs4}>Expiration &nbsp;</label>
                    <Field
                      type='number'
                      name='expiry'
                      component='input'
                      className="form-control no-spinners"
                      placeholder='mmyy'
                      maxLength='4'
                      onKeyUp={this.handleNotToExceedLength}
                      style={{ maxWidth: '180px' }}
                    />
                  </FormGroup>
                  <FormGroup sm={5}>
                    <label className={style.lblattrs4}>CVC &nbsp;</label>
                    <Field
                      type='number'
                      name='cvc'
                      component='input'
                      className="form-control no-spinners"
                      maxLength='3'
                      onKeyUp={this.handleNotToExceedLength}
                      style={{ maxWidth: '180px' }}
                      placeholder='###'
                    />
                  </FormGroup>
                  <FormGroup sm={5}>
                    <label className={style.lblattrs4}>Deposit Amount &nbsp;</label>
                    <Field
                      type='number'
                      name='depositAmount'
                      max={999}
                      component='input'
                      className="form-control no-spinners"
                      style={{ maxWidth: '180px' }}
                    />
                  </FormGroup>
                  <FormGroup sm={4}>
                    <Button className='btn btn-success' style={{ marginLeft: '33%' }} onClick={this.handleMakePayment}>
                      <i className={savingDeposit === true ? "fa fa-spinner fa-spin" : "fa fa-credit-card"} aria-hidden="true" />&nbsp;&nbsp;Make Deposit
						</Button>
                  </FormGroup>
                </div>
                <div className='col-sm-4' style={{ marginLeft: '-50px', marginTop: '8px' }}>
                  <FormGroup md={3}>
                    <Cards
                      number={ccnumber}
                      name={nameoncard}
                      expiry={expiration}
                      cvc={cvc}
                      focused='name'
                    />
                  </FormGroup>
                </div>
              </Col>
            )
          }
        </form>
      </div>)
  }
}
EventDeposit.propTypes = {
  handleSubmit: PropTypes.func,
  dispatch: PropTypes.func,
  eventId: PropTypes.number,
  eventname: PropTypes.string,
  nameoncard: PropTypes.string,
  ccnumber: PropTypes.string,
  expiration: PropTypes.string,
  cvc: PropTypes.string,
  depositAmount: PropTypes.string,
  depositPaidOn: PropTypes.string,
  depositConfirmation: PropTypes.string,
  saveComponentState: PropTypes.bool,
  onComponentStateSaved: PropTypes.func,
  componentStateSaved: PropTypes.bool,
  currentWizardStep: PropTypes.number,
  savingDeposit: PropTypes.bool,
  updateDepositErrors: PropTypes.object,
  seasons: PropTypes.array,
  eventseason: PropTypes.string
}

function mapStateToProps(state, ownProps) {
  const formName = ownProps.form
  const selector = formValueSelector(formName)
  const eventId = selector(state, 'eventId')
  const eventname = selector(state, 'eventname')
  const nameoncard = selector(state, 'name')
  const ccnumber = selector(state, 'ccnumber')
  const expiration = selector(state, 'expiry')
  const cvc = selector(state, 'cvc')
  const depositAmount = selector(state, 'depositAmount')
  const depositPaidOn = selector(state, 'depositPaidOn')
  const componentStateSaved = selector(state, 'componentStateSaved');
  const currentWizardStep = selector(state, 'currentWizardStep');
  const savingDeposit = selector(state, 'savingDeposit');
  const updateDepositErrors = selector(state, 'updateDepositErrors');
  const depositConfirmation = selector(state, 'depositConfirmation');
  const minRequiredDeposit = selector(state, 'minRequiredDeposit');
  const seasons = selector(state, 'seasons');
  const eventseason = selector(state, 'eventseason');

  return {
    eventId,
    eventname,
    nameoncard,
    ccnumber,
    expiration,
    cvc,
    depositAmount,
    depositPaidOn,
    depositConfirmation,
    componentStateSaved,
    currentWizardStep,
    savingDeposit,
    updateDepositErrors,
    minRequiredDeposit,
    seasons,
    eventseason
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    saveDeposit,
    savingEventDeposit,
    prestineNavigateNext
  }, dispatch);
}
export default reduxForm({
  form: FormName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(EventDeposit))



// WEBPACK FOOTER //
// ./src/containers/event/components/deposit/index.js